import React from 'react';

const PlayerContext = React.createContext([{}, () => {}]);

export default PlayerContext;
